"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioService = void 0;
class StudioService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Logon
     * @param requestBody
     * @returns StudioLogonResponseModel Successful Response
     * @throws ApiError
     */
    studioLogon(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/logon',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Studio Age Verification Start
     * @param kycPersonId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationStart(kycPersonId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/ageverification/start/{kyc_person_id}',
            path: {
                'kyc_person_id': kycPersonId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Studio Age Verification Resend
     * @param individualId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationResend(individualId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/ageverification/resend/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Studio Age Verification Status
     * @returns StudioAVStatus Successful Response
     * @throws ApiError
     */
    studioStudioAgeVerificationStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/ageverification/status',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Refresh Token
     * @returns TokenRefreshResponseModel Successful Response
     * @throws ApiError
     */
    studioRefreshToken() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/session/refresh/token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Logoff
     * @returns LogoffResponseModel Successful Response
     * @throws ApiError
     */
    studioLogoff() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/session/logoff',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Info
     * @returns any Successful Response
     * @throws ApiError
     */
    studioInfo() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/kyc/info',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Upsert
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    studioUpsert(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/kyc/upsert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Classifiers Get
     * @param requestBody
     * @returns ClassifiersGetResponse Successful Response
     * @throws ApiError
     */
    studioClassifiersGet(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/classifiers/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Studio Payment History
     * @returns StudioPaymentHistory Successful Response
     * @throws ApiError
     */
    studioGetStudioPaymentHistory() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/paymentdetailsupdate/paymenthistory',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Revenue Details
     * @param chathostId
     * @returns ChathostRevenueDetails Successful Response
     * @throws ApiError
     */
    studioGetRevenueDetails(chathostId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/info/{chathost_id}',
            path: {
                'chathost_id': chathostId,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost List Payments
     * @param chathostId
     * @returns ChathostPayment Successful Response
     * @throws ApiError
     */
    studioGetChathostListPayments(chathostId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/studio/revenuedetails/listpayments/{chathost_id}',
            path: {
                'chathost_id': chathostId,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost Payment Details
     * @param requestBody
     * @returns PaymentDetailsResponse Successful Response
     * @throws ApiError
     */
    studioGetChathostPaymentDetails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/studio/revenuedetails/paymentdetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.StudioService = StudioService;
